import { ICON_SIZE, IconButton } from "@shared/components/icon-button";
import { ICartInput } from "@types";
import ImageComponent from "@shared/components/image";
import { resolveThumbnailSources } from "utils/product-image";
import { FC, useEffect, useState, MouseEvent } from "react";
import { useCartContext } from "@context/cart";
import Link from "next/link";
import { handleCourseUrl } from "@utils/handleCourseUrl";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button/types";
import ArrowLeft from "@svg/new-design/arrow-left";
import AddedCartIcon from "@svg/new-design/added-cart";
import LoadingCircleIcon3 from "@svg/new-design/loading-circle-3";
import CartIcon from "@svg/new-design/cart";
import classNames from "classnames";
import { Button } from "@shared/components";

interface Props {
  data: ICartInput;
  icon?: React.ReactElement;
}

const ProgramListCard: FC<Props> = ({ data, icon }) => {
  const { addItem } = useCartContext();
  const [isLoading, setIsLoading] = useState(false);

  const [isInCart, setIsInCart] = useState(data.in_cart);

  const clickHandler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    setIsLoading(true);
    const response = isInCart
      ? undefined
      : await addItem({ id: Number(data.id) });
    setIsLoading(false);

    if (response) {
      setIsInCart(!isInCart);
    }
  };
  const href = handleCourseUrl(data.type, data.slug);

  useEffect(() => {
    setIsInCart(data.in_cart);
  }, [data]);
  const showBuyBasket = !data.is_buy;
  const isFree = data.price === 0;
  const image = resolveThumbnailSources(data);
  return (
    <Link target="_blank" href={href} prefetch={false}>
      <div className="px-2  border-fds-cart active:border-fds-brand hover:border-fds-brand-light border rounded-8 py-1.5  items-center flex gap-2  w-full overflow-hidden">
        <div className="relative rounded-4  min-w-16 overflow-hidden h-12  ">
          <ImageComponent
            src={image.src}
            fallbackSrcs={image.fallbackSrcs}
            alt={data.title}
            fill
            className="object-cover"
          />
        </div>
        <p className=" title-sm  sm:line-clamp-1  line-clamp-2 sm:title-md-medium grow text hover:text-fds-brand">
          {data.title}
        </p>
        <div className="hidden sm:block">
          {showBuyBasket ? (
            isFree ? (
              <Button
                variant={BUTTON_VARIANT.TEXT_ACTION}
                size={BUTTON_SIZE.MEDIUM}
                color={BUTTON_COLOR.NEUTRAL}
                endIcon={<ArrowLeft />}
              >
                شروع یادگیری
              </Button>
            ) : (
              <IconButton
                size={ICON_SIZE.MEDIUM}
                onClick={clickHandler}
                disabled={isLoading}
                icon={
                  icon ? (
                    icon
                  ) : isInCart ? (
                    <AddedCartIcon />
                  ) : isLoading ? (
                    <LoadingCircleIcon3 />
                  ) : (
                    <CartIcon />
                  )
                }
                iconClassName={classNames(
                  isLoading ? "animate h-6 w-6 animate-spin" : "",
                  "cursor-default  md:h-6 md:w-6 h-5 w-5"
                )}
                className="relative z-10 min-w-10"
                title="افزودن به سبد خرید"
                aria-label="افزودن به سبد خرید"
              />
            )
          ) : null}
        </div>
      </div>
    </Link>
  );
};

export default ProgramListCard;
